"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FolderShieldSolid: function() {
        return FolderShieldSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FolderShieldSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V8C23 6.34315 21.6569 5 20 5H12.6056C12.4081 5 12.2151 4.94156 12.0509 4.83205L10.0585 3.50385C9.56575 3.17531 8.98672 3 8.39445 3H4ZM12.6736 9.2609C12.2919 8.91304 11.7081 8.91303 11.3264 9.26089C10.8048 9.73621 10.1529 10 9.37504 10H9.00004C8.44777 10 8.00006 10.4482 8.00004 11.0004L8 12.0554C8 14.4079 9.58149 16.3999 11.7465 16.9673C11.9127 17.0109 12.0873 17.0109 12.2535 16.9673C14.4185 16.3999 16 14.4079 16 12.0554V11C16 10.4477 15.5515 10 14.9992 10H14.625C13.8471 10 13.1951 9.7362 12.6736 9.2609Z",
        fill: "currentColor"
    })
}), "FolderShieldSolid");
const _default = FolderShieldSolid;
